export const MATOMO_EVENTS_CONFIG = [
  {
    action: 'click',
    element: '.lang.pl',
    category: 'top_menu',
    name: 'change_language_pl'
  },
  {
    action: 'click',
    element: '.lang.en',
    category: 'top_menu',
    name: 'change_language_eng'
  },
  {
    action: 'click',
    element: '.lang.uk',
    category: 'top_menu',
    name: 'change_language_uk'
  },
  {
    action: 'click',
    element: '.logo',
    category: 'top_menu',
    name: 'logo'
  },
  {
    action: 'click',
    element: '.login-link',
    category: 'top_menu',
    name: 'login'
  },
  {
    action: 'click',
    element: '#link-terms',
    category: 'footer',
    name: 'regulamin'
  },
  {
    action: 'click',
    element: '#link-invoice',
    category: 'footer',
    name: 'faktura_za_doladowanie'
  },
  {
    action: 'click',
    element: '#link-faq',
    category: 'footer',
    name: 'faq'
  },
  {
    action: 'click',
    element: '#link-about',
    category: 'footer',
    name: 'o_firmie'
  },
  {
    action: 'click',
    element: '#link-contact',
    category: 'footer',
    name: 'kontakt'
  },
  {
    action: 'click',
    element: '#link-press',
    category: 'footer',
    name: 'biuro_prasowe'
  },
  {
    action: 'click',
    element: '#link-news',
    category: 'footer',
    name: 'komunikaty'
  },
  {
    action: 'click',
    element: '#link-job',
    category: 'footer',
    name: 'praca'
  },
  {
    action: 'click',
    element: '#link-privacy',
    category: 'footer',
    name: 'polityka_prywatnosci'
  },
  {
    action: 'click',
    element: '#link-site-map',
    category: 'footer',
    name: 'mapa_strony'
  },
  {
    action: 'click',
    element: '.topup-phone',
    category: 'first_step',
    name: 'phone_number'
  },
  {
    action: 'click',
    element: '#form-email',
    category: 'first_step',
    name: 'email_adres'
  },
  {
    action: 'click',
    element: '#add-topup',
    category: 'first_step',
    name: 'add_number'
  },
  {
    action: 'click',
    element: '#submit-step-1',
    category: 'first_step',
    name: 'go_to_step_2_cta'
  },
  {
    action: 'click',
    element: '.remove-topup',
    category: 'first_step',
    name: 'delete_number'
  },
  {
    action: 'click',
    element: '#link-promo',
    category: 'second_step',
    name: 'promo_link'
  },
  {
    action: 'click',
    element: '.topup-10',
    category: 'second_step',
    name: '10_pln'
  },
  {
    action: 'click',
    element: '.topup-20',
    category: 'second_step',
    name: '20_pln'
  },
  {
    action: 'click',
    element: '.topup-30',
    category: 'second_step',
    name: '30_pln_highlighted'
  },
  {
    action: 'click',
    element: '.topup-50',
    category: 'second_step',
    name: '50_pln'
  },
  {
    action: 'click',
    element: '.topup-100',
    category: 'second_step',
    name: '100_pln'
  },
  {
    action: 'click',
    element: '#topup-amount-other',
    category: 'second_step',
    name: 'different_amount'
  },
  {
    action: 'click',
    element: '#go-back-step-2',
    category: 'second_step',
    name: 'go_back_button'
  },
  {
    action: 'click',
    element: '#submit-step-2',
    category: 'second_step',
    name: 'go_to_step_3_cta'
  },
  {
    action: 'select',
    element: '#checkAll',
    category: 'third_step',
    name: 'wszystkie zgody'
  },
  {
    action: 'select',
    element: '#agreement',
    category: 'third_step',
    name: 'zgoda_regulamin'
  },
  {
    action: 'select',
    element: '#payment',
    category: 'third_step',
    name: 'wykonanie_uslugi'
  },
  {
    action: 'click',
    element: '#submit-step-3',
    category: 'third_step',
    name: 'go_to_step_4_cta'
  },
  {
    action: 'click',
    element: '#go-back-step-3',
    category: 'third_step',
    name: 'go_back_button'
  },
  {
    action: 'click',
    element: '#topup-again',
    category: 'thx_page',
    name: 'doladuj_ponownie'
  },
  {
    action: 'show',
    element: '.phone-error',
    category: 'mistake',
    name: 'numer_nie_moze_byc_doladowany'
  },
  {
    action: 'show',
    element: '.email-error',
    category: 'mistake',
    name: 'e_mail_jest_nieprawidlowy'
  },
  {
    action: 'show',
    element: '.topup-amount-message',
    category: 'mistake',
    name: 'nieprawidlowa_kwota'
  }
]
